import { render } from "./AddGps.vue?vue&type=template&id=089908a4"
import script from "./AddGps.vue?vue&type=script&lang=js"
export * from "./AddGps.vue?vue&type=script&lang=js"
script.render = render

export default script